import { hasKey } from "./typeGuards";

export function convertDateStringValuesToDate<T extends object>(response: object): T {
    const dateRegex = /^\d{4}-\d{1,2}-\d{1,2}/;
    const dateKeyRegex = /date|expiration/i;
    const processedResponse = {} as Record<string, unknown>;
    Object.entries(response).forEach(([key, value]) => {
        if (hasKey(response, key) && dateKeyRegex.test(key) && typeof value === "string" && dateRegex.test(value)) {
            processedResponse[key] = new Date(value);
        } else {
            processedResponse[key] = value as unknown;
        }
    });
    return processedResponse as T;
}
